module.exports = __webpack_public_path__ + "9f2c41f06011e8f8082a9dff1c67331d.svg";